"use client";

import { ChevronRight, Loader2 } from "lucide-react";
import React from "react";
import { useFormStatus } from "react-dom";
import { Button, type ButtonProps } from "~/components/ui/button";

export default function SubmitButton({
  className,
  pendingName = "",
  name = "",
  size = "default",
  Icon = ChevronRight,
  variant = "default",
  onClick,
  disabled,
}: {
  className?: string;
  pendingName?: string;
  name?: string;
  Icon?: React.ElementType;
  size?: ButtonProps["size"];
  variant?: ButtonProps["variant"];
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
}) {
  const { pending } = useFormStatus();
  return (
    <Button
      type="submit"
      disabled={pending || disabled}
      variant={variant}
      onClick={onClick}
      className={className}
      size={size}
    >
      {pending ? (
        <Loader2 className="mr-2 h-4 w-4 animate-spin" />
      ) : (
        <Icon className="mr-2 h-4 w-4" />
      )}
      {pending ? pendingName : name}
    </Button>
  );
}
